// extracted by mini-css-extract-plugin
export default {"title":"InfoFiled_title__F9dHv","list":"InfoFiled_list__5ymzk"};